import { FilterDropdown } from '@ui';
import { OrganTransportationTypeSettingsType, SuggestedSettingsEnum } from '@lp/features/RoutePlanner/types';
import { TravelTypeHosTx } from '@/api/apis/mission-planner';
import { DH_TXC_TRANSPORTATION_LIST_ITEMS, DH_TXC_TRANSPORTATION_TYPE_NAME } from './config';
import { SuggestedSelectTrigger } from './SuggestedSelectTrigger';

type OrganTransportationDropdownProps = {
  data: OrganTransportationTypeSettingsType;
  handleSettingsChange: (data: OrganTransportationTypeSettingsType) => void;
};

export const OrganTransportationDropdown = ({ data, handleSettingsChange }: OrganTransportationDropdownProps) => {
  return (
    <FilterDropdown
      key={data.type}
      placement="top-start"
      title="DH-TXC transportation"
      items={DH_TXC_TRANSPORTATION_LIST_ITEMS}
      disallowEmptySelection
      renderCustomTrigger={(isOpen) => (
        <SuggestedSelectTrigger
          title="DH-TXC transportation:"
          value={DH_TXC_TRANSPORTATION_TYPE_NAME[data.value]}
          isOpen={isOpen}
        />
      )}
      selectedKeys={data.value ? [data.value] : []}
      mode="single"
      onSelectedKeysChange={([selected]) =>
        handleSettingsChange({
          type: SuggestedSettingsEnum.OrganTransportationType,
          value: (selected as TravelTypeHosTx) ?? data.value,
        })
      }
    />
  );
};
